import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Building, Mail, Gavel } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const LegalPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FDFBF7] p-4 md:p-8" data-testid="legal-page">
      <div className="max-w-4xl mx-auto">
        <button
          data-testid="legal-back-btn"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-slate-600 hover:text-primary mb-4 md:mb-6 transition-colors text-sm"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour
        </button>

        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl md:text-4xl font-bold text-primary-900 font-heading mb-3 md:mb-4 flex items-center gap-3">
            <Gavel className="w-8 h-8 md:w-10 md:h-10 text-primary" />
            Mentions légales
          </h1>
        </div>

        <Card className="mb-6">
          <CardContent className="p-4 md:p-8 prose max-w-none">
            <h2 className="text-2xl font-bold text-primary-900 mb-4 flex items-center gap-2">
              <Building className="w-6 h-6 text-primary" />
              Éditeur de la plateforme
            </h2>
            <div className="bg-slate-50 p-6 rounded-xl mb-6">
              <p className="mb-2"><strong>Raison sociale :</strong> CREATIVE MEDIA</p>
              <p className="mb-2"><strong>Forme juridique :</strong> Entreprise Individuelle (E.I.)</p>
              <p className="mb-2"><strong>SIRET :</strong> 507 909 307 00054</p>
              <p className="mb-2"><strong>SIREN :</strong> 507 909 307</p>
              <p className="mb-2"><strong>RCS :</strong> Orléans</p>
              <p className="mb-2">
                <strong>Siège social :</strong> 10 Place de l'Église, 45450 Donnery, France
              </p>
              <p className="mb-2">
                <strong>Email :</strong> <a href="mailto:contact@carelio.fr" className="text-primary underline">contact@carelio.fr</a>
              </p>
              <p className="text-sm text-slate-600 mt-3 italic">
                Les informations complémentaires (TVA intracommunautaire, téléphone) seront communiquées lors du passage en production commerciale.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-primary-900 mb-4">Directeur de la publication</h2>
            <p className="mb-6">Le représentant légal de CREATIVE MEDIA.</p>

            <h2 className="text-2xl font-bold text-primary-900 mb-4">Hébergement</h2>
            <div className="bg-primary-50 border-l-4 border-primary p-4 rounded-r-xl mb-6">
              <p className="font-semibold text-primary-900 mb-2">Hébergement sécurisé</p>
              <p className="mb-2"><strong>Hébergeur :</strong> Emergent Labs</p>
              <p className="mb-2"><strong>Infrastructure :</strong> Cloud sécurisé (Union européenne)</p>
              <p className="text-sm text-slate-600 mt-2">
                L'hébergement des données de la plateforme Carelio est assuré sur une infrastructure sécurisée.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-primary-900 mb-4">Propriété intellectuelle</h2>
            <p className="mb-4">
              L'ensemble du contenu de la plateforme Carelio (structure, design, textes, graphismes, logos, icônes, etc.)
              est la propriété exclusive de <strong>CREATIVE MEDIA</strong> et est protégé par les lois françaises et
              internationales relatives à la propriété intellectuelle. La marque <strong>Carelio</strong> est exploitée
              par CREATIVE MEDIA.
            </p>
            <p className="mb-4">
              Toute reproduction, représentation, modification, publication, adaptation totale ou partielle est strictement
              interdite sans l'autorisation écrite préalable de CREATIVE MEDIA.
            </p>

            <h2 className="text-2xl font-bold text-primary-900 mb-4">Données personnelles</h2>
            <p className="mb-4">
              Carelio traite des données personnelles et des <strong>données de santé</strong> dans le respect du <strong>Règlement Général sur la Protection des Données (RGPD)</strong> et de la loi Informatique et Libertés modifiée.
            </p>
            <p className="mb-4">
              Pour plus d'informations, consultez notre
              <a href="/confidentialite" className="text-primary hover:underline ml-1">
                Politique de confidentialité
              </a>.
            </p>

            <h2 className="text-2xl font-bold text-primary-900 mb-4">Cookies</h2>
            <p className="mb-4">
              Carelio utilise des cookies essentiels au fonctionnement de la plateforme et, avec votre consentement,
              des cookies d'analyse. Vous pouvez gérer vos préférences via le bandeau de consentement.
            </p>

            <h2 className="text-2xl font-bold text-primary-900 mb-4">Loi applicable et juridiction compétente</h2>
            <p className="mb-4">
              Les présentes mentions légales sont soumises au <strong>droit français</strong>. En cas de litige, et
              après tentative de résolution amiable, compétence exclusive est attribuée aux tribunaux du ressort du
              siège social de CREATIVE MEDIA (<strong>Orléans, Loiret</strong>), sous réserve des dispositions
              impératives applicables aux consommateurs.
            </p>

            <h2 className="text-2xl font-bold text-primary-900 mb-4">Contact</h2>
            <div className="bg-secondary-50 p-6 rounded-xl">
              <p className="flex items-start gap-2 mb-2">
                <Building className="w-5 h-5 text-secondary mt-0.5" />
                <span><strong>Adresse :</strong> CREATIVE MEDIA — 10 Place de l'Église, 45450 Donnery</span>
              </p>
              <p className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-secondary" />
                <strong>Email :</strong>
                <a href="mailto:contact@carelio.fr" className="text-primary underline ml-1">contact@carelio.fr</a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LegalPage;
